import { useMediaQuery } from '@mui/material';
import { useTheme } from '@mui/material/styles';

/**
 * Returns Boolean values for various viewport sizes.
 * Useful for doing conditional logic based on viewport size.
 *
 * @deprecated
 * Please either use 'useMediaQuery' directly, or the 'useViewport' hook, both of which exist in
 * /src/components-v2/hooks.
 */
export const useViewportDimensions = () => {
  const theme = useTheme();

  const isMobileViewport = useMediaQuery(theme.breakpoints.down('sm'));
  const isSmallViewport = useMediaQuery(theme.breakpoints.down('md'));
  const isMediumViewport = useMediaQuery(theme.breakpoints.down('lg'));
  const isLargeViewport = useMediaQuery(theme.breakpoints.down('xl'));
  const isXLargeViewport = useMediaQuery(theme.breakpoints.up('xl'));

  const hasMinHeightOf400px = useMediaQuery('(min-height:400px)');
  const isMobileLandscapeViewport = !hasMinHeightOf400px && isSmallViewport;

  return {
    isLargeViewport,
    isMediumViewport,
    isMobileLandscapeViewport,
    isMobileViewport,
    isSmallViewport,
    isXLargeViewport,
  };
};
